import ContentHeader from './ContentHeader';
import './ContentHeader.scss';

export default ContentHeader;